
<template>
<div>
  <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
        <router-link :to="{ path: '/allnews'}">
          <button type="submit" class="btn btn-info active btn-sm px-3 mr-3">Haberler</button>
        </router-link>
        <router-link :to="{ path: '/allnews-order'}">
          <button type="submit" class="btn btn-warning btn-sm px-3 mr-3">Haber Sıralaması</button>
        </router-link>

      </div>
      <span></span>
    </div>
  <card>
    <div v-if="!err">

    
    <h4 slot="header" class="card-title">
      Tüm Haberler 
      <router-link v-b-tooltip title="Yeni Sayfa Oluştur" :to="{ path: 'allnews/add'}" class="btn btn-primary btn-fill float-md-right" tag="li"><i class="fas fa-plus"></i> Yeni Haber</router-link>
    </h4>
    <table class="table table-hover table-striped table-bordered mb-0">
      <caption >Toplam: {{total}}</caption>
      <thead class="thead-dark">
        <th>Sayfa</th>
        <th>URL</th>
        <th>Kategori</th>
        <th>Yayın Tarihi</th>
        <th style="width:15%">İşlemler</th>
      </thead>
      <tbody>
        <tr v-for="item in table" :key="item.id">
          <td>{{item.name}}</td>
          <td>{{item.url}}</td>
          <td>{{item.category.name}}</td>
          <td>{{item.created | moment("Do/MM/YYYY HH:mm:ss")}} </td>
          <td>
            <router-link :to="{ path: 'allnews/edit/'+item.id}" v-b-tooltip title="Düzenle" class="btn btn-primary btn-fill btn-xs" tag="li"><i class="fas fa-edit"></i></router-link>
            <router-link :to="{ path: 'allnews/slider/'+item.id}" v-b-tooltip title="Slider" class="btn btn-warning btn-fill btn-xs" tag="li"><i class="fas fa-images"></i></router-link>
            <router-link :to="{ path: 'allnews/gallery/'+item.id}" v-b-tooltip title="Galeri" class="btn btn-success btn-fill btn-xs" tag="li"><i class="far fa-image"></i></router-link>
            <router-link :to="{ path: 'allnews/pdf/'+item.id}" v-b-tooltip title="Pdf" class="btn btn-info btn-fill btn-xs" tag="li"><i class="far fa-file-pdf"></i></router-link>
            <!-- <a href="#" class="btn btn-xs btn-success btn-fill" v-b-tooltip title="Önizleme"><i class="fas fa-eye"></i> {{item.view_count}}</a> -->
            <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-if="item.status !== 4 " v-on:click="changeStatus(item.id,4)" v-b-tooltip title="Yayından Kaldır" id="deactivate-item.id"><i class="fas fa-eye-slash"></i></a>
            <a href="javascript:void(0)" class="btn btn-xs btn-success btn-fill" v-if="item.status === 4" v-b-tooltip v-on:click="changeStatus(item.id,1)" title="Yayına al" id="activate-item.id"><i class="fas fa-eye"></i></a>
            <a href="#" class="btn btn-xs btn-dark btn-fill" v-b-tooltip  title="Okunma Sayısı"><i class="fa fa-book" ></i> {{item.readed}}</a>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation small">

      <ul class="pagination justify-content-end">
        <li class="page-item" v-bind:class="{disabled: isFirst()}"><a class="page-link" v-on:click="getPosts(page - 1,type)" >Öncesi</a></li>
        <li class="page-item" v-for="current in pageCount" v-if="isInScope(current)" v-bind:class="{active: isActive(current), 'mr-2': current == 1, 'ml-2': current == pageCount.length}" :key="current"><a href="javascript:void(0)" class="page-link active" v-on:click="getPosts(current,type)">{{current}}</a></li>
        <li class="page-item" v-bind:class="{disabled: isLast()}"><a class="page-link" v-on:click="getPosts(page + 1,type)">Sonrası</a></li>
      </ul>
    </nav>
    </div>
  <div v-if="err">
    {{err}}
  </div>

  </card>
</div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        post:{
          status:1
        },
        table: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'News',
        viewCounts: [],
        err:null
      }
    },
    components: {
      Card
    },

    methods: {
      changeStatus: function(id,status){
        this.toggleLoader()
        this.post.status = status
        this.$http.post('/api/posts/edit/' + id, this.post).then(
          response => {
            if(!status){
              this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı')
            }else{
              this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı')
            }
            
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
                     this.toggleLoader();
                                                                                                          if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
          })
      },
      isInScope: function(c){
        if(c === 1){
          return true
        }
        if(c === this.pageCount.length){
          return true
        }
        if(c - this.page > 3 || this.page - c > 3){
          return false;
        }
        return true
      },
      isActive: function (v) {
        return v === this.page
      },
      isFirst: function () {
        return this.page === 1
      },
      isLast: function () {
        return this.page === Math.ceil(this.total / this.limit)
      },
      getPosts: function (p = 1, t = 'Allnews') {
        this.toggleLoader()
        this.type = t
        var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p
        this.$http
        .get(url)
        .then(
          response => {
            this.table = response.body.data
            this.total = response.body.meta.total
            this.page = p
            this.pageCount = []
            for (var i = 0; i < this.total / this.limit; i++) {
              this.pageCount.push(i + 1)
            }
            this.toggleLoader()
          },
          er => {
                    this.toggleLoader();

if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
          }
          )
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getPosts()
      })
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostModules/Allnews/Index.vue